import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * SegmentedControl — Floating Segmented Control (sekcja 8.4).
 * Kompaktowy przełącznik z animowanym tłem aktywnego segmentu.
 * Maksymalnie 3-4 opcje.
 */
function SegmentedControl({ options = [], value, onChange }) {
  const theme = useTheme();
  const activeIndex = options.findIndex((o) => o.value === value);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        position: 'relative',
        bgcolor: theme.palette.action.hover,
        borderRadius: `${theme.tokens?.primitive?.radius?.pill ?? 999}px`,
        p: 0.5,
      }}
    >
      {/* Animated background for active segment */}
      <Box
        sx={{
          position: 'absolute',
          top: 4,
          bottom: 4,
          left: `calc(${(activeIndex / options.length) * 100}% + 4px)`,
          width: `calc(${100 / options.length}% - 8px)`,
          bgcolor: 'background.paper',
          borderRadius: `${theme.tokens?.primitive?.radius?.pill ?? 999}px`,
          boxShadow: theme.tokens?.semantic?.shadow?.soft,
          transition: `left ${theme.tokens?.primitive?.motion?.duration?.standard ?? 240}ms ${theme.tokens?.primitive?.motion?.easing?.emphasis ?? 'cubic-bezier(0.2, 0.8, 0.2, 1)'}`,
        }}
      />
      {options.map((option) => (
        <Box
          key={option.value}
          onClick={() => onChange?.(option.value)}
          sx={{
            position: 'relative',
            zIndex: 1,
            px: 2.5,
            py: 1,
            cursor: 'pointer',
            borderRadius: `${theme.tokens?.primitive?.radius?.pill ?? 999}px`,
            userSelect: 'none',
            minWidth: 80,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: option.value === value ? 700 : 500,
              color: option.value === value ? 'text.primary' : 'text.secondary',
              transition: 'color 160ms ease',
              whiteSpace: 'nowrap',
            }}
          >
            {option.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default SegmentedControl;
